import React, {
  Component
} from 'react';
import {
  Button,
  Header,
  Icon,
  List
} from 'semantic-ui-react';

const ItemList = ({ data, loading, selectItem, removeItem }) => {
  if (loading) {
    return (
      <Header as="h2" textAlign="center" icon>
        <Icon name="cloud" />
        Cargando ...
      </Header>
    );
  } else if (!data || data.length === 0) {
    return (
      <Header as="h2" textAlign="center" icon>
        <Icon name="frown" />
        Lista Vacia
        <Header.Subheader>
          No hay elementos
        </Header.Subheader>
      </Header>
    );
  } else {
    return (
      <List divided relaxed>
        {
          data.map((item, index) => {
            return (
              <List.Item key={index}>
                {
                  removeItem &&
                    <List.Content floated="right">
                      <Button negative basic icon="trash" onClick={removeItem.bind(null, item.id)} />
                    </List.Content>
                }
                <List.Content>
                  <List.Header as="a" onClick={selectItem.bind(null, item)}>{item.header}</List.Header>
                  <List.Description as="a">
                    {item.description}
                  </List.Description>
                </List.Content>
              </List.Item>
            );
          })
        }
      </List>
    );
  }
};

export default ItemList;


// WEBPACK FOOTER //
// ./client/components/lists/ItemList.js